<template>
  <div>
    <div>
      <active-model-state-chip :jobs="related_display_jobs"></active-model-state-chip>
      <v-chip
        v-if="showEvaluationChip"
        class="job-state-chip mt-1"
        data-testid="evaluation-state-chip"
      >
        <v-avatar left>
          <v-icon>fas fa-spinner fa-spin</v-icon>
        </v-avatar>
        <div class="job-state-chip__body">
          <span class="job-state-chip__text" data-testid="evaluation-state-label">
            {{ evaluationLabel }}
          </span>
          <v-progress-linear
            v-if="evaluationProgress > 0"
            :value="evaluationProgress"
            height="6"
            rounded
            class="job-state-chip__progress mt-1"
            data-testid="evaluation-state-progress"
          />
        </div>
      </v-chip>
    </div>
  </div>
</template>

<script>

import ActiveModelStateChip from "@/components/models/ActiveModelStateChip";
import { isFailedTrainJob, parseJobDescription, friendlyJobStateLabel } from "@/utils/trainMetrics";


export default {
  name: "TrainConfigTrainingStateCell",
  props: {
    train_config: Object,
    jobs: Array,
    models: { type: Array, default: () => [] },
  },
  components: {ActiveModelStateChip},
  data () {
    return {
    }
  },
  mounted() {
    this.$store.dispatch('recalculation/ensure_subscribed');
  },
  methods: {
  },
  computed: {
    related_display_jobs() {
      const forConfig = (this.jobs || []).filter((job) => {
        try {
          const meta = parseJobDescription(job);
          return Number(meta.train_config_id) === Number(this.train_config.id);
        } catch {
          return false;
        }
      });
      const active = forConfig.filter((job) => job.processed != 1);
      if (active.length) {
        return active;
      }
      // Finished Failed jobs otherwise disappear — keep the latest visible for logs/retrain.
      const failed = forConfig
        .filter((job) => isFailedTrainJob(job))
        .sort((a, b) => Number(b.id) - Number(a.id));
      return failed.slice(0, 1);
    },
    modelIds() {
      const fromProp = (this.models || [])
        .filter((m) => Number(m.train_config_id) === Number(this.train_config.id))
        .map((m) => m.id);
      if (fromProp.length) {
        return fromProp;
      }
      // Fallback: models linked from active/failed train jobs
      return (this.related_display_jobs || [])
        .map((j) => {
          const desc = parseJobDescription(j);
          return j.model_id || desc.model_id;
        })
        .filter(Boolean);
    },
    evaluationStatus() {
      return this.$store.getters['recalculation/evaluation_status_for_models'](this.modelIds);
    },
    // Hide the post-train chip while the train job itself still shows Evaluating.
    trainJobShowsEvaluating() {
      return (this.related_display_jobs || []).some((job) => {
        if (job.processed === 1) {
          return false;
        }
        const desc = parseJobDescription(job);
        const state = String(desc.state || '').toLowerCase();
        return state.startsWith('evaluating') || !!(desc.eval_metrics);
      });
    },
    showEvaluationChip() {
      return !!this.evaluationStatus && !this.trainJobShowsEvaluating;
    },
    evaluationLabel() {
      if (!this.evaluationStatus) {
        return '';
      }
      return friendlyJobStateLabel(this.evaluationStatus.state)
        || this.evaluationStatus.state;
    },
    evaluationProgress() {
      return this.evaluationStatus ? Number(this.evaluationStatus.progress) || 0 : 0;
    },
  }
}
</script>

<style scoped>
.job-state-chip {
  max-width: 100%;
  height: auto !important;
  white-space: normal;
}
.job-state-chip__text {
  white-space: normal;
  line-height: 1.3;
  padding: 4px 0;
}
</style>
